(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultReportDeleteController',ResultReportDeleteController);

    ResultReportDeleteController.$inject = ['$uibModalInstance', 'entity', 'ResultReport'];

    function ResultReportDeleteController($uibModalInstance, entity, ResultReport) {
        var vm = this;

        vm.resultReport = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ResultReport.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
